var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgReportViolation = function SvgReportViolation(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF4D3D",
    fillRule: "evenodd",
    d: "M7 5h10c2.2 0 3.6 1.4 4.1 3.6l1.3 6.2c.45 2.2-.5 4.2-2.5 4.2-1.3 0-2.1-.7-2.9-1.8l-.8-1.1c-.4-.55-.9-.8-1.6-.8H9.4c-.7 0-1.2.25-1.6.8L7 17.2C6.2 18.3 5.4 19 4.1 19c-2 0-2.95-2-2.5-4.2l1.3-6.2C3.4 6.4 4.8 5 7 5m-.1 2.7h1.7v1.9h1.9v1.7H8.6v1.9H6.9v-1.9H5V9.6h1.9zm8.35 1.5a1.15 1.15 0 1 1 2.3 0 1.15 1.15 0 0 1-2.3 0m2.4 2.7a1.15 1.15 0 1 1 2.3 0 1.15 1.15 0 0 1-2.3 0",
    clipRule: "evenodd"
  })));
};
export default SvgReportViolation;